import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { Entry } from 'contentful';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';


@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss'],
  host: {
    '(window:scroll)': 'updateHeader($event)'
  }
})
export class ProjectComponent implements OnInit {

  public item : Entry<any>;
  public projectID : string;

  currPos: any = 0;
  opacity: any = 1.0;

  public imageWidth : number = 500;

  constructor(private contentfulService: ContentfulService,private router: Router,private route: ActivatedRoute,) { }
  
    ngOnInit() {
      this.projectID = this.route.snapshot.paramMap.get('id');
      this.item = this.contentfulService.items.find(x => x.sys.id == this.projectID);
      console.log(this.item,this.projectID);

      this.imageWidth = window.innerWidth > 1280 ? 1500 : 950;
    }

    updateHeader(evt) {
      this.currPos = evt.target.scrollingElement.scrollTop - evt.target.scrollingElement.clientTop;
      this.currPos = (this.currPos != NaN) ? this.currPos : 0;
      this.opacity =  1 - (this.currPos / 50);
    }
  
}



// WEBPACK FOOTER //
// C:/Users/timva/Documents/Work/LatestDownload/src/app/project/project.component.ts